import axios from 'axios'
import store from '@/store'

function bold(text) {
    return `*${text}*`
}
function red(text) {
    return '`' + text + '`'
}
function newline() {
    return '\n'
}
function makeBodyGDPRSafe(body) {
    if (!body) {
        return
    }
    return JSON.stringify(body).includes('password')
        ? 'cleaned due to GDPR. Request body contains password'
        : JSON.stringify(body)
}
function makeErrorGDPRSafe(error) {
    if (!error) {
        return 'none'
    }
    let textString = ''
    if (!error.response) {
        textString = JSON.stringify(error).includes('password')
            ? 'cleaned due to GDPR. Request body contains password'
            : JSON.stringify(error)
    } else {
        textString =
            error.response.data && error.response.data.error
                ? JSON.stringify(error.response.data.error)
                : ''
    }
    return textString
}
export function send500Error(error) {
    if (process.env.VUE_APP_ENV_NAME !== 'production') {
        return
    }
    try {
        const domain = window.location.host
        const state = store.state
        const method = error.config.method
        const url = error.config.url
        const body = error.config.data
        const msg = error.data.error.msg
        const user = domain.includes('vod') ? state.vod.user : state.originUser
        const jwt = user.jwt
        const type = user.type
        const message = `${bold(`Bad request!`)}${newline()}Code: ${red(
            error.status
        )}${newline()}Method: ${red(method)}${newline()}URL: ${red(
            url
        )}${newline()}RequestBody: ${red(body)}${newline()}JTW: ${red(
            jwt
        )}${newline()}UserMail: ${red(user.mail)}${newline()}UserName: ${red(
            `${user.name}`
        )}${newline()}UserType: ${red(type)}${newline()}Message: ${red(
            msg
        )}${newline()}App: ${red('WEB')}`
        axios
            .post(getApiUrl('v1/tools/slack'), {
                url:
                    'https://hooks.slack.com/services/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',
                message: message,
                channel: '#emergency',
                hash:
                    'cdbc8192dcecfa1975739b52eb8f1141a23c68e66866b8f056159d34c4fba1ef'
            })
            .catch(error => {
                console.log(error)
            })
    } catch (error) {
        console.log(error)
    }
}
export function sendFreemiumJoinFailed(messageFromQuery, form, error) {
    const queryMessage = messageFromQuery ? `(${messageFromQuery})` : ''
    const message = `${bold(
        `Problem z Freemium!!! ${queryMessage}`
    )}${newline()}Nazwa: ${red(form.schoolName)}${newline()}Imię: ${red(
        form.name
    )}${newline()}Nazwisko: ${red(form.surname)}${newline()}Email: ${red(
        form.mail
    )}${newline()}Telefon: ${red(form.phone)}${newline()}Region: ${red(
        store.state.region
    )}${newline()}Błąd: ${red(makeErrorGDPRSafe(error))}`
    sendFreemium(message)
}
export function sendSchoolJoinFailed(messageFromQuery, form, error) {
    const queryMessage = messageFromQuery ? `(${messageFromQuery})` : ''
    let message = ''
    switch (store.state.region) {
        case 'de':
            message = `${bold(
                `Schule kann nicht beitreten!!! ${queryMessage}`
            )}${newline()}Schule: ${red(
                form.schoolName
            )}${newline()}Vorname: ${red(form.name)}${newline()}Nachname: ${red(
                form.surname
            )}${newline()}Email: ${red(
                form.mail
            )}${newline()}Telefonnumer: ${red(
                form.phone
            )}${newline()}Error: ${red(makeErrorGDPRSafe(error))}`
            sendTrialDE(message)
            break
        case 'ch':
            message = `${bold(
                `Schule kann nicht beitreten!!! ${queryMessage}`
            )}${newline()}Schule: ${red(
                form.schoolName
            )}${newline()}Vorname: ${red(form.name)}${newline()}Nachname: ${red(
                form.surname
            )}${newline()}Email: ${red(
                form.mail
            )}${newline()}Telefonnumer: ${red(
                form.phone
            )}${newline()}Error: ${red(makeErrorGDPRSafe(error))}`
            sendTrialCH(message)
            break
        case 'pl':
            message = `${bold(
                `Placówka nie może dołączyć!!! ${queryMessage}`
            )}${newline()}Nazwa: ${red(form.schoolName)}${newline()}Imię: ${red(
                form.name
            )}${newline()}Nazwisko: ${red(
                form.surname
            )}${newline()}Email: ${red(form.mail)}${newline()}Telefon: ${red(
                form.phone
            )}${newline()}Błąd: ${red(makeErrorGDPRSafe(error))}`
            sendTrialPL(message)
            break
    }
}
export function sendFreemiumJoined(messageFromQuery, form) {
    const queryMessage = messageFromQuery ? `(${messageFromQuery})` : ''
    const message = `${bold(
        `Nowe freemium! ${queryMessage}`
    )}${newline()}Nazwa: ${red(form.schoolName)}${newline()}Imię: ${red(
        form.name
    )}${newline()}Nazwisko: ${red(form.surname)}${newline()}Email: ${red(
        form.mail
    )}${newline()}Telefon: ${red(form.phone)}${newline()}Region: ${red(
        store.state.region
    )}`
    sendFreemium(message)
}
export function sendSchoolJoined(messageFromQuery, form) {
    const queryMessage = messageFromQuery ? `(${messageFromQuery})` : ''
    var message = ''
    switch (store.state.region) {
        case 'de':
            message = `${bold(
                `Neue Schule! ${queryMessage}`
            )}${newline()}Schule: ${red(
                form.schoolName
            )}${newline()}Vorname: ${red(form.name)}${newline()}Nachname: ${red(
                form.surname
            )}${newline()}Email: ${red(
                form.mail
            )}${newline()}Telefonnumer: ${red(form.phone)}${newline()}`
            sendTrialDE(message)
            break
        case 'ch':
            message = `${bold(
                `Neue Schule! ${queryMessage}`
            )}${newline()}Schule: ${red(
                form.schoolName
            )}${newline()}Vorname: ${red(form.name)}${newline()}Nachname: ${red(
                form.surname
            )}${newline()}Email: ${red(
                form.mail
            )}${newline()}Telefonnumer: ${red(form.phone)}${newline()}`
            sendTrialCH(message)
            break
        case 'pl':
            message = `${bold(
                `Nowa placówka! ${queryMessage}`
            )}${newline()}Nazwa: ${red(form.schoolName)}${newline()}Imię: ${red(
                form.name
            )}${newline()}Nazwisko: ${red(
                form.surname
            )}${newline()}Email: ${red(form.mail)}${newline()}Telefon: ${red(
                form.phone
            )}${newline()}`
            sendTrialPL(message)
            break
    }
}
export function presenceMealError(params) {
    if (!params) {
        return
    }
    const { payload, dataSource, mealTime, mealsToInsert } = params
    const model = payload && payload.model ? payload.model : {}
    const kid = payload && payload.kid ? payload.kid : {}
    const errorPayload = {
        model: {
            day: model.day,
            no_meals: model.no_meals,
            default_meals: model.default_meals,
            meals: model.meals
        },
        kid: {
            id: kid.id,
            diet: kid.diet
        },
        dataSource: dataSource,
        mealTime: mealTime,
        mealsToInsert: mealsToInsert
    }
    const person = store.state.originUser ? store.state.originUser : {}
    const message = `${bold(
        `Posiłek ma przypisaną nieprawidłową porę posiłków (WEB)!!!`
    )}
		${bold('Imię i nazwisko:')}${red(person.name)}
		${bold('Email:')} ${red(person.mail)}
		${bold('Błąd:')} ${red(JSON.stringify(errorPayload))}`
    sendErrors(message)
}
export async function unknownError777(error) {
    if (!error || !error.config) {
        return
    }
    const { method, url, data } = error.config
    const user = store.state.originUser || {}
    const errorMsg = makeErrorGDPRSafe(error)
    const jwt = store.state.user ? store.state.user.jwt : 'none'
    const message = `${bold(`Bad request!`)}
	${bold('Code:')} ${red(-777)}
	${bold('Method:')} ${red(method)}
	${bold('URL:')} ${red(url)}
	${bold('RequestBody:')} ${red(makeBodyGDPRSafe(data))}
	${bold('JTW:')} ${red(jwt)}
	${bold('UserID:')} ${red(`${user.account_id}`)}
	${bold('UserMail:')} ${red(`${user.mail}`)}
	${bold('UserName:')} ${red(`${user.name}`)}
	${bold('Message:')} ${red(`${errorMsg}`)}
	${bold('App:')} ${red('WEB')}`
    process.env.NODE_ENV == 'production'
        ? sendErrors(message)
        : sendDevErrors(message)
}
export function webAppImportError(
    importType,
    errorType,
    schoolName,
    email,
    id
) {
    let message
    message = `${bold(
        `Bład użytkownika! (${importType})`
    )}${newline()}Błąd: ${red(errorType)}${newline()}Nazwa placówki: ${red(
        schoolName
    )}${newline()}Adres placówki: ${red(email)}${newline()}ID placówki: ${red(
        id
    )}`
    sendCST(message)
}
function getApiUrl(url) {
    const region = store.state.region ? store.state.region : 'pl'
    return `${process.env.VUE_APP_API_URL.replace('{region}', region)}${url}`
}
export function sendStorageRequest() {
    if (process.env.VUE_APP_ENV_NAME !== 'production') {
        return
    }
    const { region, user, originUser } = store.state
    const { mail, name } = originUser
    const school = user.school_name
    const message = `${bold(`Nowy request!!`)}${newline()}Nazwa: ${red(
        school
    )}${newline()}Imię i nazwisko: ${red(name)}${newline()}Email: ${red(
        mail
    )}${newline()}Region: ${red(region)}`
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url:
                'https://hooks.slack.com/services/T6JRGGXMG/B012V60CRGE/qwQyD59MVFBmBuzrgnvhGq2',
            message: message,
            channel: '#storage_request',
            hash:
                '94e52ce803f060d9563d46242fc72b9cf58ba9adc1d3972d1911af96af34c2fe'
        })
        .catch(error => {
            console.log(error)
        })
}
export function sendFreemiumRequest() {
    if (process.env.VUE_APP_ENV_NAME !== 'production') {
        return
    }
    const { region, user, originUser } = store.state
    const { mail, name } = originUser
    const school = user.school_name
    const message = `${bold(`Nowy request!!`)}${newline()}Nazwa: ${red(
        school
    )}${newline()}Imię i nazwisko: ${red(name)}${newline()}Email: ${red(
        mail
    )}${newline()}Region: ${red(region)}`
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url:
                'https://hooks.slack.com/services/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',
            message: message,
            channel: '#freemium_request',
            hash:
                '4d0b013af35b3884bb475783a3d509f34cd90888e6b676e7703a797fc1b60a3d'
        })
        .catch(error => {
            console.log(error)
        })
}
function sendFreemium(message) {
    if (process.env.VUE_APP_ENV_NAME !== 'production') {
        return
    }
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url:
                'https://hooks.slack.com/services/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',
            message: message,
            channel: '#freemium',
            hash:
                'd3ae397ab15e6de9f0dd2686f7b179e29e80ceca936413fa3c40911539c0658c'
        })
        .catch(error => {
            console.log(error)
        })
}
function sendTrialPL(message) {
    if (process.env.VUE_APP_ENV_NAME !== 'production') {
        return
    }
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url:
                'https://hooks.slack.com/services/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',
            message: message,
            channel: '#trial_pl',
            hash:
                'c48170ac6ec502c3d046a4f9f8e7948e3301bda6f4bcb095a5a6111fc92a986b'
        })
        .catch(error => {
            console.log(error)
        })
}
function sendTrialDE(message) {
    if (process.env.VUE_APP_ENV_NAME !== 'production') {
        return
    }
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url:
                'https://hooks.slack.com/services/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',
            message: message,
            channel: '#trial_de',
            hash:
                '94f6c1212b7fc11fb4d4deb96006bc93170aff57c4931dc75cb3dc7dae5e830f'
        })
        .catch(error => {
            console.log(error)
        })
}
function sendTrialCH(message) {
    if (process.env.VUE_APP_ENV_NAME !== 'production') {
        return
    }
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url:
                'https://hooks.slack.com/services/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',
            message: message,
            channel: '#trial_ch',
            hash:
                'c3f2fe2cfcdc05104530a9c3c6d84ba78c9363cb291e9b6db34abc1d2da022e1'
        })
        .catch(error => {
            console.log(error)
        })
}
function sendCST(message) {
    if (process.env.VUE_APP_ENV_NAME !== 'production') {
        return
    }
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url:
                'https://hooks.slack.com/services/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',
            message: message,
            channel: '#cs_team_automation',
            hash:
                '363f4a309c6dc39572a5050b6d3d72c85539844248ba76ad5000113dee4f5fc1'
        })
        .catch(error => {
            console.log(error)
        })
}
function sendErrors(message) {
    if (process.env.VUE_APP_ENV_NAME !== 'production') {
        return
    }
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url:
                'https://hooks.slack.com/services/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',
            message: message,
            channel: '#errors',
            hash:
                '865e22f9211901346d2c6722369b7a6b7ba02adcecf7b070a7908d75eca53016'
        })
        .catch(error => {
            console.log(error)
        })
}
function sendDevErrors(message) {
    if (process.env.NODE_ENV == 'production') {
        return
    }
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url:
                'https://hooks.slack.com/services/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',
            message: message,
            channel: '#dev_errors',
            hash:
                '07e4439f373bf9c63a853cf79da63f724afc74f55344bbe876980dd0636b3932'
        })
        .catch(error => {
            console.log(error)
        })
}
